import { render, staticRenderFns } from "./ResourceLogin.vue?vue&type=template&id=37ed36c8"
import script from "./ResourceLogin.vue?vue&type=script&lang=js"
export * from "./ResourceLogin.vue?vue&type=script&lang=js"
import style0 from "./ResourceLogin.vue?vue&type=style&index=0&id=37ed36c8&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports